<template>
  <div class="account-page">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <!-- Page Content -->
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-10 offset-md-1">
              <!-- Account Content -->
              <div class="account-content">
                <div class="row align-items-center justify-content-center">
                  <div class="col-md-7 col-lg-6 login-left">
                    <img
                      src="@/assets/img/login-banner.png"
                      class="img-fluid"
                      alt="Login Banner"
                    />
                  </div>
                  <div class="col-md-12 col-lg-5 login-right">
                    <div class="login-header">
                      <h3>Forgot Password?</h3>
                    </div>

                    <!-- Forgot Password Form -->

                    <div class="form-group form-focus">
                      <input
                        maxlength="10"
                        @keypress="onlyNumber"
                        v-model="mobile_no"
                        class="form-control floating inputPrice"
                      />
                      <label class="focus-label">Mobile No</label>
                    </div>
                    <div class="text-right">
                      <router-link class="forgot-link" to="/login-with-username"
                        >Remember your password?</router-link
                      >
                    </div>

                    <button
                      class="btn btn-primary btn-block btn-lg login-btn"
                      type="submit"
                      :disabled="!mobile_no.match('[0-9]{10}')"
                      @click="send_otp()"
                    >
                      Send OTP
                    </button>

                    <!-- /Forgot Password Form -->
                  </div>
                </div>
              </div>
              <!-- /Account Content -->
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
      <layout-footer></layout-footer>
    </div>
  </div>
</template>

<script>
import CommonApi from "../../services/CommonApi";
export default {
  data() {
    return {
      mobile_no: "",
    };
  },
  methods: {
    //Allow User to type number only
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },

    send_otp() {
      if (this.mobile_no) {
        this.$swal({
          text: "Sending OTP...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        var bodyFormData = new FormData();
        bodyFormData.append("phone", this.mobile_no);
        CommonApi.post_data("sahaj.api.send_otp", bodyFormData, true).then(
          (res) => {
            if (res.status_code == 200) {
              this.$router.push({
                name: "forgot-password-enter-OTP",
                params: { mobile: this.mobile_no },
              });
              this.$swal.close();
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Error",
                text: res.message,
                showConfirmButton: true,
              });
            }
          }
        );
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/kneexpert/ForgotPassword.vue